import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { agreementRowActions } from './AgreementRowMenuActions.utils';
import ShareAgreementLinksModal from './ShareAgreementLinksModal';
export function useAgreementRowMenuActions() {
    const { t: rowActionTexts } = useLocaleKeys('agreement.dashboard.rowActions');
    const overlayContext = useOverlayContext();
    const navigate = useNavigate();
    const linksModalContent = (agreement)=>(props)=>/*#__PURE__*/ _jsx(ShareAgreementLinksModal, _object_spread_props(_object_spread({}, props), {
                id: agreement.id,
                customerName: agreement.customerName,
                status: agreement.status
            }));
    const shareLinks = (agreement)=>overlayContext.showModal({
            biName: 'share_agreement_links_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: linksModalContent(agreement)
        });
    return (args)=>agreementRowActions({
            args,
            texts: rowActionTexts,
            handlers: {
                onShareLinks: ()=>shareLinks(args.agreement),
                onNavigate: (route)=>navigate(route),
                routes: routes.agreementMinisiteRoutes(args.agreement.id)
            }
        });
}
